/* global window */
import React from 'react';
import FullPageError from '../Components/FullPageError';

const refreshPage = (err) => {
    class RefreshPage extends React.Component {
        componentDidMount() {
            if (process.env.NODE_ENV !== 'production') {
                throw err;
            }
            const sign = window.location.href.indexOf('?') === -1 ? '?' : '&';
            window.location.href += `${sign}reload`;
        }
        render() {
            return (<FullPageError />);
        }
    }
    return RefreshPage;
};

export default refreshPage;



// WEBPACK FOOTER //
// ./src/client/hoc/refreshPage.js